import ZakelijkPaymentPriceTable from "./ZakelijkPaymentPriceTable";
import ZakelijkPaymentProductItemExtra from "./ZakelijkPaymentProductItemExtra";
import ZakelijkPaymentProductsTotal from "./ZakelijkPaymentProductsTotal";
import ZakelijkPaymentSidebarProductsList from "./ZakelijkPaymentSidebarProductsList";

const ZakelijkPaymentSidebarProducts = () => {
  return (
    <section className="gg-grid">
      <div className="gg-rounded-sm gg-bg-grey-500">
        <div className="gg-px-5 gg-pb-7 gg-pt-9 xl:gg-px-9">
          <ZakelijkPaymentSidebarProductsList />
        </div>
        <div className="gg-border-t gg-px-5 gg-py-7 xl:gg-pl-9 xl:gg-pr-5">
          <ZakelijkPaymentPriceTable />

          <div className="gg-col-span-12 gg-grid gg-w-full gg-grid-cols-12 gg-pt-2">
            <ZakelijkPaymentProductItemExtra className="gg-col-span-12 gg-text-dark-blue-700 xl:gg-col-span-8" />
            <ZakelijkPaymentProductsTotal
              className={"gg-col-span-12 gg-justify-self-end xl:gg-col-span-12"}
            />
          </div>
        </div>
      </div>
    </section>
  );
};
export default ZakelijkPaymentSidebarProducts;
